import { createAction } from '@reduxjs/toolkit';

export const openLixaniPaintDialog = createAction(
  'lixaniPaint/openLixaniPaintDialog'
);

export const closeLixaniPaintDialog = createAction(
  'lixaniPaint/closeLixaniPaintDialog'
);

export const setLixaniPaintImage = createAction(
  'lixaniPaint/setLixaniPaintImage'
);
